var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("g", { stroke: "none", strokeWidth: 1, fill: "currentColor", fillRule: "evenodd" },
            React.createElement("rect", { x: 11, y: 21.997, width: 26, height: 3, rx: 1.5 }),
            React.createElement("path", { d: "M23.573 21.798c.472.204 1.045.038 1.28-.37l7.046-6.733a.736.736 0 00.101-.369c0-.456-.427-.825-.954-.825h-5.903V8.988C25.143 8.443 24.63 8 24 8c-.586 0-1.07.382-1.135.873l-.008.116V13.5h-5.902c-.1 0-.197.014-.29.04l-.137.048c-.472.204-.663.7-.427 1.107l7.045 6.733a.9.9 0 00.427.37zM23.573 25.087c.472-.204 1.045-.038 1.28.37L31.9 32.19c.067.114.101.24.101.369 0 .456-.427.825-.954.825h-5.903v4.512c0 .546-.512.989-1.143.989-.586 0-1.07-.382-1.135-.873l-.008-.116v-4.511h-5.902c-.1 0-.197-.014-.29-.04l-.137-.048c-.472-.204-.663-.7-.427-1.107l7.045-6.733a.9.9 0 01.427-.37z", fillRule: "nonzero" }))));
});
